exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__tagList___2hHnV{width:45rem}.style__tagRow___P_E2r{background-color:none!important}.style__triageEntryContiner___2E37X{margin-bottom:2rem}.style__triageControls___2FfJH{margin-top:1rem}.style__dbControls___3JUZO{display:flex;justify-content:space-between;margin-right:1rem}.style__closeIcon___2rBXZ{cursor:pointer}", "", {"version":3,"sources":["/./containers/triage/style.css"],"names":[],"mappings":"AAAA,wBACC,WAAa,CACb,AAED,uBACC,+BAAkC,CAClC,AAED,oCACC,kBAAoB,CACpB,AAED,+BACC,eAAiB,CACjB,AAED,2BACC,aAAc,AACd,8BAA+B,AAC/B,iBAAmB,CACnB,AAED,0BACC,cAAgB,CAChB","file":"style.css","sourcesContent":[".tagList {\n\twidth: 45rem;\n}\n\n.tagRow {\n\tbackground-color: none !important;\n}\n\n.triageEntryContiner {\n\tmargin-bottom: 2rem;\n}\n\n.triageControls {\n\tmargin-top: 1rem;\n}\n\n.dbControls {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-right: 1rem;\n}\n\n.closeIcon {\n\tcursor: pointer;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"tagList": "style__tagList___2hHnV",
	"tagRow": "style__tagRow___P_E2r",
	"triageEntryContiner": "style__triageEntryContiner___2E37X",
	"triageControls": "style__triageControls___2FfJH",
	"dbControls": "style__dbControls___3JUZO",
	"closeIcon": "style__closeIcon___2rBXZ"
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!/data/www/SGDBackend-Nex2/~/postcss-loader!./containers/triage/style.css
// module id = 569
// module chunks = 0